import { Directive, HostListener } from '@angular/core';
import { MAX_PHONE_DIGITS, Patterns } from '../utils/constants';

@Directive({
	selector: '[appValidatePhone]',
})
export class ValidatePhoneDirective {
	@HostListener('paste', ['$event'])
	onPaste(event: ClipboardEvent): void {
		event.preventDefault();
		let pasted = event.clipboardData?.getData('text') ?? '';
		pasted = pasted.replace(Patterns.onlyDigits, '').slice(0, MAX_PHONE_DIGITS);

		const input = event.target as HTMLInputElement;
		input.value = pasted;
		input.dispatchEvent(new Event('input'));
	}
}
